"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEAD_CELL_CATEGORY_KEY = 'base';
exports.HEAD_CELL_PARENT_COMPONENT_KEY = 'table';
exports.HEAD_CELL_COMPONENT_KEY = 'headCell';